import { ENVIRONMENT_INFO } from "../environmentInfo.mjs";

const BASE_URL = ENVIRONMENT_INFO.VR.baseUrl;

async function httpJson(path, { method = "GET", body } = {}) {
  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`HTTP ${res.status} ${res.statusText} ${path} ${text ? `| ${text}` : ""}`);
  }

  // 204 or empty body safe-guard
  const ct = res.headers.get("content-type") || "";
  if (!ct.includes("application/json")) {
    return null;
  }
  return await res.json();
}

export async function searchEntity(entity, { columns = [], query = null, limit = 50, offset = 0 } = {}) {
  return await httpJson(`${entity}/search`, {
    method: "POST",
    body: { columns, query, limit, offset },
  });
}

export async function readPerson(id) {
  return await httpJson(`person/${encodeURIComponent(id)}`, { method: "GET" });
}

export async function readEntity(entity, id) {
  return await httpJson(`${entity}/${encodeURIComponent(id)}`, { method: "GET" });
}

export async function readUserAccountRequest(gid) {
  return await readEntity("user-account-request", gid);
}

export async function approveUserAccountRequest(gid, body = {}) {
  return await httpJson(`user-account-request/${encodeURIComponent(gid)}/approve`, {
    method: "POST",
    body,
  });
}

export async function rejectUserAccountRequest(gid, body = {}) {
  return await httpJson(`user-account-request/${encodeURIComponent(gid)}/reject`, {
    method: "POST",
    body,
  });
}